import { createTheme } from '@material-ui/core'

const config = {
    palette: {
        primary: {
            main: '#3c3c3c'
        },
        secondary: {
            main: '#d4d4d4'
        },
        error: {
            main: '#ff5454'
        }
    },
    cta: '#F0C338',
    background: '#fff',
    active: '#5cc0ff',
    error: '#ff5454',
    primary: '#3c3c3c',
    textPrimary: '#3c3c3c',
    textPrimaryReverted: '#ffffff',
    shareIconColor: '#a9a9a9',
    checkIconColor: '#039855',
    mailIconColor: '#000000',
    primaryHover: '#636363',
    revertedHover: '#ececec',
    secondary: '#d4d4d4',
    textSecondary: '#737373',
    tertiary: '#f5f5f5',
    quaternary: '#9c9c9c',
    quinary: '#ededed',
    warning: '#ff9800',
    green: '#027A48',
    greenLight: '#ECFDF3',
    blue: '#175CD3',
    blueLight: '#EFF8FF',
    lightBlueGrey: '#F9FAFB',
    blueDark: '#425167',
    grayLight: '#EAECF0',
    gray: '#344054',

    underlaySecondary: '#f5f5f5',
    borderRadius: 7,
    borderWidth: 0.5,
    border: '0.5px solid #d4d4d4',
    borderRadius50: '50%',
    borderRadius10: 10,
    fontFamily: 'Inter',
    /* assets */
    mainLogo: '/assets/img/main-logo.jpeg',
    loginLogo: '/assets/img/login-logo.png',
    typography: {
        fontFamily: `"Inter", "Roboto", "Helvetica", sans-serif`,
        body0: {
            fontWeight: 100
        },
        body1: {
            fontWeight: 100
        },
        body2: {
            fontWeight: 100
        }
    },
    breakpoints: {
        values: {
            xs: 0, // extra small devices (phones)
            sm: 768, // small devices (tablets)
            md: 960, // medium devices (desktops)
            lg: 1280, // large devices (large desktops)
            xl: 1920 // extra large devices
        }
    },
    link: {
        color: '#3c3c3c',
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.3
        }
    }
}

const polar = createTheme(config)

export default polar
